<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},

};
</script>

<style>
/* 全局样式表 */
html,
body,
#app,
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>